import { Menu, Theme, styled } from '@mui/material';

export const StyledLangMenuWrap = styled('div', {
	shouldForwardProp: (prop) => prop !== 'isOpen',
})(({ isOpen }: { isOpen: boolean; theme: Theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	paddingInline: '8px',
	paddingTop: '8px',
	marginTop: '-8px',
	transition: 'all .3s',
	borderRadius: '12px 12px 0px 0px',
	background: isOpen ? '#fff' : 'transparent',
	cursor: 'pointer',
	order: '-1',
}));

export const StyledLangMenu = styled(Menu)({
	'& .MuiPopover-paper': {
		borderRadius: '0px 0px 12px 12px',
		background: '#FFF',
		boxShadow: '7px 35px 30px 0px #827D8326',
	},
});
